export const normalizeFile = (e: any) => {
    console.log(e);
    if (Array.isArray(e)) {
        if(e?.[0]?.size > 5000000) throw 'Размер баннера не должен превышать 5МБ';
        return e;
    }
    if(e?.fileList?.[0]?.size > 5000000) throw 'Размер баннера не должен превышать 5МБ';
    return e?.fileList;
};